import store from '@zoom/storage'

export function getLocalstorage(key) {
  return store.get(key)
}

export function setLocalstorage(key, value) {
  return store.set(key, value)
}

export function removeLocalstorage(itemName) {
  return store.remove(itemName)
}

export function getSessionStorage(key) {
  return store.session.get(key)
}
export function setSessionStorage(key, value) {
  return store.session.set(key, value)
}
